import React, { useState } from 'react'
import { Stack, Button, Box, Typography, Container } from "@mui/material";
import colors from '../theme/colors'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom"

export const QuestionaryLevel = ({ image, buttonText, setModo }) => {
    const navigate = useNavigate()

    const goToEjes = () => {
        setModo().then(
            () => { navigate("/Ejes") },
            (e) => {
                console.error("Error: " + e)
            }
        );
    }
    return (
        <Stack
            direction={{ xs: 'column', md: 'column', lg: 'column' }}
            justifyContent="center"
            alignItems="center"
            padding={'2em'}
            spacing={2}
        >
            <Box component="img" src={image} alt="modos" sx={{ flex: '1', width: { xs: '200px', md: '130px' }, height: 'auto' }}></Box>
            <Button variant="contained" sx={{ flex: '1' }} onClick={goToEjes}>
                {buttonText}
            </Button>
        </Stack>
    );
};
